


















import { defineComponent } from '@vue/composition-api';
import BasePage from '@front-app/components/layouts/BasePage.vue';
import PaddedContent from '@front-app/components/layouts/columns/PaddedContent.vue';
import SiteFooter from '@front-app/components/Footer.vue';

export default defineComponent({
	components: {
		BasePage,
		PaddedContent,
		SiteFooter,
	},
	setup() {
		return {};
	},
});
